export default __webpack_public_path__ + "static/media/otege_lebak_bulus.c80fc084.png";